export class IFramePlayerEventVO {
    msFromStart;
    timeFromStart;
    type;
    iframePlayer;
    data;
    error;
    target;
    targetName;
    sendPostMessage;
    constructor(type = undefined, iframePlayer = undefined, data = undefined, error = undefined, target = undefined, targetName = undefined, sendPostMessage = true) {
        this.type = type;
        this.iframePlayer = iframePlayer;
        this.data = data;
        this.error = error;
        this.target = target;
        this.targetName = targetName;
        this.sendPostMessage = sendPostMessage;
    }
}
